<template>
<div class="checkbox">
    <input 
        type="checkbox" 
        :id="name" 
        :name="name" 
        v-model="value"
        @change="$emit('change', {name, value, impossible, items})"
    />
    <label :for="name">{{ title }}</label>
</div>
</template>
<script>
export default {
    name: 'Checkbox',
    data: () => {
        return {
            value: false
        }
    },
    props: {
        title: {
            type: String,
            require: true
        },
        default: {
            type: [Boolean, Number],
            require: true
        },
        name: {
            type: String,
            require: false
        },
        impossible: {
            type: String,
            require: false
        },
        items: {
            type: Array,
            require: false
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        changeValue (val) {
            this.value = val
        }
    },
    watch: {
        'default': 'changeValue'
    },
    mounted () {
        this.value = this.default
    }
}
</script>
<style lang="stylus" scoped>
.checkbox
    display flex
    align-items center
    input[type=checkbox]
        transform scale(0.8)

    label
        margin-left 15px
        font-size 14px
        font-weight 500
        cursor pointer

.transition, input[type=radio]:after, input[type=checkbox][type=radio]:after, input[type=checkbox]:after
    -moz-transition all 0.25s cubic-bezier(0.75, 0.01, 0.48, 2)
    -o-transition all 0.25s cubic-bezier(0.75, 0.01, 0.48, 2)
    -webkit-transition all 0.25s cubic-bezier(0.75, 0.01, 0.48, 2)
    transition all 0.25s cubic-bezier(0.75, 0.01, 0.48, 2)

.bgTransition, input[type=radio]:before, input[type=checkbox][type=radio]:before, input[type=checkbox]:before
    -moz-transition all 0.25s ease-in-out
    -o-transition all 0.25s ease-in-out
    -webkit-transition all 0.25s ease-in-out
    transition all 0.25s ease-in-out

input[type=radio], input[type=checkbox]
    position relative
    cursor pointer
    min-width 30px
    width 30px
    height 30px

input[type=radio]:before, input[type=radio]:after, input[type=checkbox]:before, input[type=checkbox]:after
    content ""
    position absolute

input[type=radio]:before, input[type=checkbox]:before
    height 100%

input[type=radio][type=radio], input[type=checkbox][type=radio]
    border-radius 30px

input[type=radio][type=radio]:before, input[type=checkbox][type=radio]:before
    width 100%
    border-radius 30px
    background-color #2c3f52
    box-shadow 0 0 0 1px #2c3f52

input[type=radio][type=radio]:after, input[type=checkbox][type=radio]:after
    width 100%
    height 100%
    border-radius 30px
    background-color #15202a
    -moz-transform scale(0, 0)
    -ms-transform scale(0, 0)
    -webkit-transform scale(0, 0)
    transform scale(0, 0)

input[type=radio][type=radio]:checked:after, input[type=checkbox][type=radio]:checked:after
    -moz-transform scale(0.75, 0.75)
    -ms-transform scale(0.75, 0.75)
    -webkit-transform scale(0.75, 0.75)
    transform scale(0.75, 0.75)

input[type=radio][type=radio]:checked:before, input[type=checkbox][type=radio]:checked:before
    background-color #85ff7a
    box-shadow 0 0 0 1px #85ff7a

input[type=radio][type=checkbox]:before, input[type=checkbox][type=checkbox]:before
    width 200%
    background-color #2c3f52
    box-shadow 0 0 0 1px #2c3f52
    -moz-transform translate(-25%, 0)
    -ms-transform translate(-25%, 0)
    -webkit-transform translate(-25%, 0)
    transform translate(-25%, 0)
    border-radius 30px

input[type=radio][type=checkbox]:after, input[type=checkbox][type=checkbox]:after
    width 80%
    height 80%
    margin-top 10%
    margin-left 10%
    background-color #15202a
    border-radius 30px
    -moz-transform translate(-60%, 0)
    -ms-transform translate(-60%, 0)
    -webkit-transform translate(-60%, 0)
    transform translate(-60%, 0)

input[type=radio][type=checkbox]:checked:after, input[type=checkbox][type=checkbox]:checked:after
    -moz-transform translate(60%, 0)
    -ms-transform translate(60%, 0)
    -webkit-transform translate(60%, 0)
    transform translate(60%, 0)

input[type=radio][type=checkbox]:checked:before, input[type=checkbox][type=checkbox]:checked:before
    background-color #85ff7a
    box-shadow 0 0 0 1px #85ff7a


input
    display block
    margin 0 12px


</style>